import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Navbar from '../homepage/components/Navbar.jsx';
import eclipseerlogo from './eclipseer-logo.png';
import { authAPI } from '../../services/apiClient';
import styles from './ForgotPassword.module.css';

const ForgotPasswordRequest = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
      setError('Email is required.');
      return;
    }

    setIsLoading(true);
    try {
      const response = await authAPI.initiatePasswordResetEmail({ email: trimmedEmail });
      setSuccess(
        response?.data?.message ||
        'If your email is registered, you will receive a password reset link shortly.'
      );
    } catch (err) {
      setError(
        err?.response?.data?.error ||
        err?.message ||
        'Could not process this request. Please try again.'
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <Navbar currentPage="home" setPage={() => {}} />
      <div className={styles.main}>
        <section className={styles.leftPanel}>
          <img src={eclipseerlogo} alt="Eclipseer Logo" className={styles.logo} />
          <h1 className={styles.panelTitle}>Forgot Password</h1>
          <p className={styles.panelText}>
            Enter your registered email address. If an account exists, we will send you a secure
            password reset link that expires in 1 hour.
          </p>
        </section>

        <section className={styles.rightPanel}>
          <h2 className={styles.heading}>Reset Link Request</h2>
          <p className={styles.subheading}>
            Check your inbox after submitting. The reset link is one-time use and email-specific.
          </p>

          {success && <div className={styles.messageSuccess}>{success}</div>}
          {error && <div className={styles.messageError}>{error}</div>}

          <form onSubmit={handleSubmit} className={styles.form}>
            <label htmlFor="resetEmail" className={styles.label}>Registered Email</label>
            <input
              id="resetEmail"
              type="email"
              className={styles.input}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              autoComplete="email"
              required
              disabled={isLoading}
            />

            <div className={styles.actions}>
              <button
                type="submit"
                className={styles.primaryButton}
                disabled={isLoading}
              >
                {isLoading ? 'Sending...' : 'Send Reset Link'}
              </button>

              <button
                type="button"
                className={styles.secondaryButton}
                onClick={() => navigate('/login')}
                disabled={isLoading}
              >
                Back to Login
              </button>
            </div>
          </form>

          <p className={styles.note}>
            Already remember your password? <Link to="/login" className={styles.link}>Sign In</Link>
          </p>
        </section>
      </div>
    </div>
  );
};

export default ForgotPasswordRequest;

